/** @format */

export const SHOW_GOBACK = {
  create: "create",
  edit: "edit",
};

export const PUBLIC_URL = {
  LOGIN: "/dang-nhap",
};

export const PRIVATE_ROOT = {
  DASHBOARD: "/",
  TASKS: "/cong-viec",
  PROJECTS: "/du-an",
  PROJECTS_CREATE: "/du-an/tao-moi",
  PROJECTS_DETAIL: "/du-an/chi-tiet",
  USERS: "/nguoi-dung",
  SETTINGS: "/cai-dat",
  ACCOUNT_CODES: "/tai-khoan-hach-toan",
  COMPANIES: "/cong-ty",
  CUSTOMERS: "/khach-hang",
  WMS_CODES: "/ma-hang-hoa",
  WMS_ITEM_GROUPS: "/nhom-hang-hoa",
  WMS_ITEMS: "/hang-hoa",
  OBJECTIVE_CUSTOMER_OR_SUPLIES: "/doi-tuong/khach-hang-nha-cung-cap",
  OBJECTIVE_EMPLOYEE: "/doi-tuong/nhan-vien",
  OBJECTIVE_DEPARTMENT: "/doi-tuong/phong-ban",
  OBJECTIVE_UNIT: "/doi-tuong/don-vi",
};

export const ACCOUNTING = {
  OPENING_INVENTORY: "/ke-toan/ton-kho-dau-ky",
  OPENING_DEBT: "/ke-toan/cong-no-dau-ky",
  CASH_RECEIPT: "/ke-toan/phieu-thu-tien-mat",
  CASH_RECEIPT_CREATE: "/ke-toan/phieu-thu-tien-mat/tao-moi",
  CASH_RECEIPT_DETAIL: "/ke-toan/phieu-thu-tien-mat/chi-tiet",
  BANK_RECEIPT: "/ke-toan/phieu-thu-ngan-hang",
  BANK_RECEIPT_CREATE: "/ke-toan/phieu-thu-ngan-hang/tao-moi",
  BANK_RECEIPT_DETAIL: "/ke-toan/phieu-thu-ngan-hang/chi-tiet",
  CASH_PAYMENT: "/ke-toan/phieu-chi-tien-mat",
  CASH_PAYMENT_CREATE: "/ke-toan/phieu-chi-tien-mat/tao-moi",
  CASH_PAYMENT_DETAIL: "/ke-toan/phieu-chi-tien-mat/chi-tiet",
  BANK_PAYMENT: "/ke-toan/phieu-chi-ngan-hang",
  BANK_PAYMENT_CREATE: "/ke-toan/phieu-chi-ngan-hang/tao-moi",
  BANK_PAYMENT_DETAIL: "/ke-toan/phieu-chi-ngan-hang/chi-tiet",
  BANK_ACCOUNTS: "/ke-toan/tai-khoan-ngan-hang",
  PURCHASE_DOCUMENT: "/ke-toan/chung-tu-mua",
  PURCHASE_RETURN: "/ke-toan/tra-hang-mua",
  PURCHASE_RETURN_CREATE: "/ke-toan/tra-hang-mua/tao-moi",
  PURCHASE_RETURN_DETAIL: "/ke-toan/tra-hang-mua/chi-tiet",
  SALES_DOCUMENT: "/ke-toan/chung-tu-ban",
  OTHER_DOCUMENT: "/ke-toan/chung-tu-khac",
  PRODUCTION_ORDER: "/ke-toan/lenh-san-xuat",
  MATERIAL_SPLIT: "/ke-toan/phan-bo-vat-tu",
  PAYROLL_LIST: "/ke-toan/bang-luong",
  PAYROLL_PAYMENT: "/ke-toan/chi-luong",
  INVENTORY_CHECK: "/ke-toan/kiem-ke",
  WMS_IN: "/ke-toan/nhap-kho",
  WMS_OUT: "/ke-toan/xuat-kho",
  WMS_TRANSFER: "/ke-toan/dieu-chuyen-kho",
  RECALCULATE_COST: "/ke-toan/tinh-gia-lai",
  NOTIFICATION: "/ke-toan/thong-bao",
  CLOSE_BOOK: "/ke-toan/khoa-so",
  ACCOUNTING_SETTING: "/ke-toan/thiet-lap",
};
